document.addEventListener("click", async (event) => {
  const link = event.target.closest('a[href^="#"]');
  if (!link) return;

  const linkId = link.getAttribute("href").slice(1);
  if (!linkId) return;

  const modal = document.querySelector(`dialog-component[data-modal-link="${CSS.escape(linkId)}"]`);
  if (!modal) return;

  event.preventDefault();

  const openDialog = link.closest("dialog-component");
  if (openDialog && openDialog !== modal) await openDialog.closeDialog();

  modal.showDialog();
});

document.addEventListener("submit", (event) => {
  event.target.closest(".modal-block dialog-component")?.closeDialog();
});

customElements.whenDefined("dialog-component").then(() => {
  const target = location.hash && document.getElementById(location.hash.slice(1));
  if (target) target.closest(".modal-block dialog-component")?.showDialog();
});
